import { Component, HostListener, Input, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { PaymentMethodsOther } from '../../interfaces/payment-methods';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { Session } from '../../interfaces/session-data';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { InitData } from "../../interfaces/visa-src/InitData";
import { MaskedData } from "../../interfaces/visa-src/MaskedData";
import { Subject } from "rxjs";

@Component({
  selector: 'app-other-selection',
  templateUrl: './other-selection.component.html',
  styleUrls: ['./other-selection.component.scss']
})
export class OtherSelectionComponent implements OnInit {
  @Input('paymentMethodsOther') paymentMethodsOther: PaymentMethodsOther[];
  @Input('cols') cols: number;
  @Input('mobile') mobile: boolean;
  @Input('sessionData') sessionData: Session;
  @ViewChild('groupOther') groupOther: MatTabGroup;
  @ViewChild('tabOther') tabsOther: MatTab;
  @ViewChild('paymentTabFront') paymentTabFront: HTMLDivElement;
  @ViewChild('paymentTabBack') paymentTabBack: HTMLDivElement;
  @ViewChildren('matIconsOther') matIconsOther: [MatIcon];
  public loading: boolean = true;
  paymentMethodsOtherTabsAmount: number;
  // object per tab holder
  paymentMethodsOtherTabsObj = [];
  // 2D array containing values of each col
  paymentMethodsOtherTotalsArr = [];
  timeout;
  // card
  card: HTMLElement = undefined;
  cardFront: HTMLElement = undefined;
  cardBack: HTMLElement = undefined;
  idHolder;
  touch1 = { x: 0, y: 0, time: 0 };
  selectedIndexOther = 0;
  @Input()
  public maskedData: Subject<MaskedData> = new Subject<MaskedData>();
  public maskedDataObj: MaskedData;

  @HostListener('touchstart', ['$event'])
  @HostListener('touchend', ['$event'])
  @HostListener('touchcancel', ['$event'])
  handleTouch(ev) {
    if (
      (ev.target as HTMLElement).id === 'payment-method-image-other'
      ||
      (ev.target as HTMLElement).id === 'payment-method-image-card') {
      const touch = ev.touches[0] || ev.changedTouches[0];
      if (ev.type === 'touchstart') {
        this.touch1.x = touch.pageX;
        this.touch1.y = touch.pageY;
        this.touch1.time = ev.timeStamp;
      } else if (ev.type === 'touchend') {
        const dx = touch.pageX - this.touch1.x;
        const dy = touch.pageY - this.touch1.y;
        const dt = ev.timeStamp - this.touch1.time;

        if (dt < 500) {
          // swipe lasted less than 500 ms
          if (Math.abs(dx) > 60) {
            // delta x is at least 60 pixels
            if (dx > 0) {
              this.page(ev, 'right', 'swipe');
            } else {
              this.page(ev, 'left', 'swipe');
            }
          }
        }
      }
    } else if (ev.target.id === 'Layer_1') {
      const touch = ev.touches[0] || ev.changedTouches[0];
      if (ev.type === 'touchstart') {
        this.touch1.x = touch.pageX;
        this.touch1.y = touch.pageY;
        this.touch1.time = ev.timeStamp;
      } else if (ev.type === 'touchend') {
        const dx = touch.pageX - this.touch1.x;
        const dy = touch.pageY - this.touch1.y;
        const dt = ev.timeStamp - this.touch1.time;

        if (dt < 500) {
          // swipe lasted less than 500 ms
          if (Math.abs(dx) > 60) {
            // delta x is at least 60 pixels
            if (dx > 0) {
              this.page(ev, 'right', 'swipe');
            } else {
              this.page(ev, 'left', 'swipe');
            }
          }
        }
      }
    } else if (ev.target.ownerSVGElement) {
      if (ev.target.ownerSVGElement.id === 'cardfront') {
        const touch = ev.touches[0] || ev.changedTouches[0];
        if (ev.type === 'touchstart') {
          this.touch1.x = touch.pageX;
          this.touch1.y = touch.pageY;
          this.touch1.time = ev.timeStamp;
        } else if (ev.type === 'touchend') {
          const dx = touch.pageX - this.touch1.x;
          const dy = touch.pageY - this.touch1.y;
          const dt = ev.timeStamp - this.touch1.time;

          if (dt < 500) {
            // swipe lasted less than 500 ms
            if (Math.abs(dx) > 60) {
              // delta x is at least 60 pixels
              if (dx > 0) {
                this.page(ev, 'right', 'swipe');
              } else {
                this.page(ev, 'left', 'swipe');
              }
            }
          }
        }
      }
    }
  }

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    console.log('masked data...', this.maskedData);
    if ((this.paymentMethodsOther.filter((data) => data.paymentTypeName.toLowerCase() === 'click_to_pay').length > 0) || (this.paymentMethodsOther.filter((data) => data.code.toLowerCase() === 'click_to_pay').length > 0)) {
      if (this.maskedData) {
        this.maskedData
          .subscribe((res: MaskedData) => {
            console.log('Masked data on other selection', res);
            this.loading = false;
            this.maskedDataObj = res;
          }, (err) => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    } else {
      this.loading = false;
    }
    this.display();
  }

  onTabChanged(event) {
    let k = 0;
    this.selectedIndexOther = event.index;
    for (const elt of this.matIconsOther) {
      if (k === event.index) {
        (elt._elementRef.nativeElement as HTMLElement).textContent = 'lens';
      } else {
        (elt._elementRef.nativeElement as HTMLElement).textContent = 'trip_origin';
      }
      k++;
    }
  }

  page(event, direction: string, type: string) {
    // swipe or arrow press
    // perhaps in future add an if clause === 'other'
    if (this.card && this.cardFront && this.cardBack) {
      this.card.style.transform = 'rotateY(0deg)';
      this.cardFront.style.backfaceVisibility = 'visible';
      this.cardBack.style.backfaceVisibility = 'hidden';
      this.cardBack.style.display = 'none';
      this.cardFront.style.display = 'flex';
      this.card = undefined;
      this.cardFront = undefined;
      this.cardBack = undefined;
      this.timeout = undefined;
    }

    if (type === 'swipe') {
      if (direction === 'right') {
        return this.selectedIndexOther <= this.paymentMethodsOtherTabsAmount - 1 && this.selectedIndexOther !== 0
          ?
          this.selectedIndexOther--
          :
          this.selectedIndexOther = this.paymentMethodsOtherTabsAmount - 1;
      } else {
        return this.selectedIndexOther < this.paymentMethodsOtherTabsAmount - 1
          ?
          this.selectedIndexOther++
          :
          this.selectedIndexOther = 0;
      }
    } else {
      if (direction === 'left') {
        return this.selectedIndexOther > this.paymentMethodsOtherTabsAmount - 1 ? this.selectedIndexOther++ : this.selectedIndexOther--;
      } else {
        return this.selectedIndexOther <= this.paymentMethodsOtherTabsAmount
          ?
          this.selectedIndexOther++
          :
          this.selectedIndexOther = 0;
      }
    }


  }

  display() {
    this.paymentMethodsOtherTabsAmount = Math.ceil(this.paymentMethodsOther.length / this.cols);
    this.paymentMethodsOtherTabsObj = [];
    this.paymentMethodsOtherTotalsArr = [];

    for (const elt of this.paymentMethodsOther) {
      const lowercasedCode = elt.code.toLowerCase();
      // get img urls into obj
      elt.imgUrl = `../../../assets/icons/Payment_Cards/svg/image_${lowercasedCode}.png`;
      elt.backgroundImg = `url('../../../assets/icons/Payment_Cards/svg/card_${lowercasedCode}.png') center`;
      // push into tabs obj and totalsArr
      this.paymentMethodsOtherTabsObj.push(elt);
      if (this.paymentMethodsOtherTabsObj.length === this.cols) {
        this.paymentMethodsOtherTotalsArr.push(this.paymentMethodsOtherTabsObj);
        this.paymentMethodsOtherTabsObj = [];
      } else if (
        this.paymentMethodsOtherTotalsArr.length === Math.floor(this.paymentMethodsOther.length / this.cols) &&
        this.paymentMethodsOtherTotalsArr.length * this.cols + this.paymentMethodsOtherTabsObj.length === this.paymentMethodsOther.length) {
        this.paymentMethodsOtherTotalsArr.push(this.paymentMethodsOtherTabsObj);
        this.paymentMethodsOtherTabsObj = [];
      }
    }
  }

  confirmPaymentMethod(id) {

    // this.googleAnalyticsService
    // .eventEmitter('view_item', 'engagement', 'view_payment_method', id.toString(), 1);

    // document.getElementById("paymentTabBack").style.height = document.getElementById("paymentTabFront").clientHeight + 'px';

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      if (this.card && this.cardFront && this.cardBack) {
        this.card.style.transform = 'rotateY(0deg)';
        this.cardFront.style.backfaceVisibility = 'visible';
        this.cardBack.style.backfaceVisibility = 'hidden';
        this.cardBack.style.display = 'none';
        this.cardFront.style.display = 'flex';
        this.card = undefined;
        this.cardFront = undefined;
        this.cardBack = undefined;
        this.timeout = undefined;
      }
    }, 8000);

    if (this.idHolder === id) {

      this.card = (document.getElementById(id) as HTMLElement);

      this.cardFront = ((document.getElementById(id) as HTMLElement).children[0] as HTMLElement);
      this.cardBack = ((document.getElementById(id) as HTMLElement).children[1] as HTMLElement);

      this.card.style.transform === 'rotateY(180deg)' ? this.card.style.transform = 'rotateY(0deg)' : this.card.style.transform = 'rotateY(180deg)';
      this.cardFront.style.backfaceVisibility === 'hidden'
        ?
        this.cardFront.style.backfaceVisibility = 'visible'
        :
        this.cardFront.style.backfaceVisibility = 'hidden'
        ;

      setTimeout(() => {
        this.cardBack.style.backfaceVisibility === 'visible'
          ?
          this.cardBack.style.backfaceVisibility = 'hidden'
          :
          this.cardBack.style.backfaceVisibility = 'visible'
          ;
        this.cardBack.style.display === 'flex' ? this.cardBack.style.display = 'none' : this.cardBack.style.display = 'flex';
        this.cardFront.style.display === 'none' ? this.cardFront.style.display = 'flex' : this.cardFront.style.display = 'none';
      }, 125);
    } else {

      this.idHolder = id;

      if (this.card && this.cardFront && this.cardBack) {
        this.card.style.transform = 'rotateY(0deg)';
        this.cardFront.style.backfaceVisibility = 'visible';
        setTimeout(() => {
          this.cardBack.style.backfaceVisibility = 'hidden';
          this.cardBack.style.display = 'none';
          this.cardFront.style.display = 'flex';
          this.card = undefined;
          this.cardFront = undefined;
          this.cardBack = undefined;
        }, 125);

        setTimeout(() => {

          this.card = (document.getElementById(id) as HTMLElement);

          this.cardFront = ((document.getElementById(id) as HTMLElement).children[0] as HTMLElement);
          this.cardBack = ((document.getElementById(id) as HTMLElement).children[1] as HTMLElement);

          // --- ---
          this.card.style.transform === 'rotateY(180deg)' ? this.card.style.transform = 'rotateY(0deg)' : this.card.style.transform = 'rotateY(180deg)';
          this.cardFront.style.backfaceVisibility === 'hidden'
            ?
            this.cardFront.style.backfaceVisibility = 'visible'
            :
            this.cardFront.style.backfaceVisibility = 'hidden'
            ;
          setTimeout(() => {
            this.cardBack.style.backfaceVisibility === 'visible'
              ?
              this.cardBack.style.backfaceVisibility = 'hidden'
              :
              this.cardBack.style.backfaceVisibility = 'visible'
              ;
            this.cardBack.style.display === 'flex' ? this.cardBack.style.display = 'none' : this.cardBack.style.display = 'flex';
            this.cardFront.style.display === 'none' ? this.cardFront.style.display = 'flex' : this.cardFront.style.display = 'none';
          }, 130);

        }, 125);

      } else {

        this.card = (document.getElementById(id) as HTMLElement);

        this.cardFront = ((document.getElementById(id) as HTMLElement).children[0] as HTMLElement);
        this.cardBack = ((document.getElementById(id) as HTMLElement).children[1] as HTMLElement);

        // --- ---
        this.card.style.transform === 'rotateY(180deg)' ? this.card.style.transform = 'rotateY(0deg)' : this.card.style.transform = 'rotateY(180deg)';
        this.cardFront.style.backfaceVisibility === 'hidden'
          ?
          this.cardFront.style.backfaceVisibility = 'visible'
          :
          this.cardFront.style.backfaceVisibility = 'hidden'
          ;
        setTimeout(() => {
          this.cardBack.style.backfaceVisibility === 'visible'
            ?
            this.cardBack.style.backfaceVisibility = 'hidden'
            :
            this.cardBack.style.backfaceVisibility = 'visible'
            ;
          this.cardBack.style.display === 'flex' ? this.cardBack.style.display = 'none' : this.cardBack.style.display = 'flex';
          this.cardFront.style.display === 'none' ? this.cardFront.style.display = 'flex' : this.cardFront.style.display = 'none';
        }, 125);
      }
    }
  }

  navigateToWallet(paymentMethod) {

    if (paymentMethod.code.toLowerCase() === 'wallet') {
      return this.router.navigate(['afripay'], { relativeTo: this.route });
    }
    else if (paymentMethod.code.toLowerCase() === 'click_to_pay') {
      console.log('setting route state', this.maskedDataObj);
      return this.router.navigate(['virtual/click_to_pay'], { state: { maskedData: this.maskedDataObj } });
    } else if (paymentMethod.code.toLowerCase() === 'eft_adumo') {
      return this.router.navigate(['virtual/adumoeft'], { state: { maskedData: this.maskedDataObj } });
    } else if (paymentMethod.code.toLowerCase() === 'eft_ozow') {
      return this.router.navigate(['virtual/ozow'], { state: { maskedData: this.maskedDataObj } });
    } else {
      return this.router.navigate([`virtual/${paymentMethod.code.toLowerCase()}`]);
    }
  }

}
